import { render, staticRenderFns } from "./sortTable.vue?vue&type=template&id=45b2cedb"
import script from "./sortTable.vue?vue&type=script&lang=js"
export * from "./sortTable.vue?vue&type=script&lang=js"
import style0 from "./sortTable.vue?vue&type=style&index=0&id=45b2cedb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports